@if (filterForm().value()) {
    <div>
        @if (!filterForm().value().searchViewOptions.isSitePrice) {
            <div>
                @if (filterForm().value().searchViewOptions.includeJudicialTransfers || filterForm().value().searchViewOptions.includeUnCertainPrices) {
                    <div class="specialconditions-wrapper">
                        <div class="specialconditions">
                            @if (
                                filterForm().value().searchViewOptions.includeJudicialTransfers && filterForm().value().searchViewOptions.includeUnCertainPrices
                            ) {
                                OBS! Statistikken viser tinglysninger og spesielle omsetninger.
                            } @else if (filterForm().value().searchViewOptions.includeJudicialTransfers) {
                                OBS! Statistikken viser tinglysninger.
                            } @else if (filterForm().value().searchViewOptions.includeUnCertainPrices) {
                                OBS! Statistikken viser spesielle omsetninger.
                            }
                            @if (filterForm().value().searchViewOptions.includeJudicialTransfers) {
                                <div class="check-box" (click)="toggleJudicialTransfer($event)">
                                    <div class="checkbox-icon" [class.selected]="filterForm().value().searchViewOptions.includeJudicialTransfers"></div>
                                    <label for="">Vis tinglysninger</label>
                                </div>
                            }
                            @if (filterForm().value().searchViewOptions.includeUnCertainPrices) {
                                <div class="check-box" (click)="toggleUnCertainPrices($event)">
                                    <div class="checkbox-icon" [class.selected]="filterForm().value().searchViewOptions.includeUnCertainPrices"></div>
                                    <label for="">Inkluder spesielle omsetninger</label>
                                </div>
                            }
                        </div>
                    </div>
                }
                @if (totals()) {
                    <market-price-statistics-header
                        [statistics]="totals()"
                        [timePeriod]="filterForm().value().timePeriod"
                        [searchViewOptions]="filterForm().value().searchViewOptions"
                    ></market-price-statistics-header>
                }

                @if (estateStats()) {
                    @for (estateStat of estateStats(); track estateStat; let i = $index) {
                        <div>
                            @if (estateStat.numberOfEstates > 0) {
                                <market-price-statistics-estate
                                    [searchViewOptions]="filterForm().value().searchViewOptions"
                                    [estateStat]="estateStat"
                                ></market-price-statistics-estate>
                            }
                        </div>
                    }
                }
            </div>
        } @else {
            <div class="market-statistics-wrapper">
                <div class="header-section">
                    <div class="section-wrapper is-header">
                        <div class="warning-text">Det foreligger ikke aggregert statistikk for tomtesalg</div>
                    </div>
                </div>
            </div>
        }
    </div>
}
